import { object, string } from 'yup';

const getFormSchemas = () => {
  const invitationCode = string().required(
    polyglot.t('sign_up.invitation.inv_code'),
  );

  const otp = string().required(polyglot.t('sign_up.invitation.otp'));

  return {
    invitationCodeOnly: object().shape({
      invitation_code: invitationCode,
    }),
    invitationCodeAndOtp: object().shape({
      invitation_code: invitationCode,
      otp,
    }),
  };
};

export default getFormSchemas;
